import { ActionType, createAsyncAction } from 'typesafe-actions'
import { Failure, Request, Success } from './types'
import { FollowupState } from '../../types'

export const fetchFollowupsByOperatorAction = createAsyncAction(
  '@followup/FETCH_FOLLOWUPS_BY_OPERATOR_REQUEST',
  '@followup/FETCH_FOLLOWUPS_BY_OPERATOR_SUCCESS',
  '@followup/FETCH_FOLLOWUPS_BY_OPERATOR_FAILURE'
)<Request, Success, Failure>()

const request = (state: FollowupState): FollowupState => ({
  ...state,
  isLoadingFetchFollowups: true
})

const success = (
  state: FollowupState,
  action: ActionType<typeof fetchFollowupsByOperatorAction.success>
): FollowupState => ({
  ...state,
  followups: action.payload.followups,
  total: action.payload.total,
  page: action.payload.page,
  totalPages: action.payload.totalPages,
  isLoadingFetchFollowups: false,
  isSuccessOnFetchFollowups: true
})

const failure = (state: FollowupState): FollowupState => ({
  ...state,
  isLoadingFetchFollowups: false,
  isErrorOnFetchFollowups: true
})

export const fetchFollowupsByOperatorHandle = { asyncAction: fetchFollowupsByOperatorAction, request, success, failure }
